module.exports = __webpack_public_path__ + "img/bolt.0a47002c.svg";